module.exports = __webpack_public_path__ + "static/media/emoticon-expression-sad-smile-smiley-svgrepo-com.6d728187.svg";